<div oui-dialog-title>
  Modification multiple
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>Close</oui-icon>
  </oui-button>
</div>
<oui-dialog-content>
  <div class="success-line">
    <oui-icon class="success-icon">check_circle_outline</oui-icon>
    <span>Le document a bien été mis à jour.</span>
  </div>
  <div class="subtitle">
    Ce document est présent dans
    <b
      >{{ dataSource.data.length }} autre@if (dataSource.data.length > 1) {
      <span>s</span>
      } opération@if (dataSource.data.length > 1) {
      <span
        >s</span
        >
      }
    </b>
    avec des Non-conformités actives :
  </div>
  <div class="flex-vertical gap-16 table-wrapper">
    <oui-table>
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="investisseur">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div class="investor-cell">
              <oui-icon class="warn-icon">report_problem</oui-icon>
              <span class="investor-name">
                {{ element?.investisseurPreset?.displayName }}
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="operationType">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            {{ element?.operationType }}
          </td>
        </ng-container>

        <ng-container matColumnDef="produit">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            {{ element?.produitPreset?.nom }}
          </td>
        </ng-container>

        <ng-container matColumnDef="montant">
          <th mat-header-cell *matHeaderCellDef class="amount-cell"></th>
          <td mat-cell *matCellDef="let element">{{ element?.montant }} €</td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </oui-table>
  </div>
  <div>Souhaitez-vous mettre à jour ce document dans les autres opérations <b>Non-conformes</b> ci-dessus ?</div>
</oui-dialog-content>

<oui-dialog-actions>
  <oui-button type="text" oui-dialog-close (click)="cancel()"> Ne pas mettre à jour les autres opérations </oui-button>
  <oui-button type="contained" class="flex-none" (click)="validate()"> Mettre à jour </oui-button>
</oui-dialog-actions>
